import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { UserService } from '@intranet/modules/users/user.service';
import { LoginService } from '@intranet/modules/login/login.service';
import { User } from '../user.types';
import { TogglService } from '../..';
import { HotkeyService } from 'src/app/core/services/hotkey.service';
import { DesktopAppService } from '@intranet/core/services/desktop-app.service';
import { TimerAppDownloadService, TimerAppDownloadInfo } from '@intranet/core/services/timer-app-download.service';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
})
export class UserSettingsComponent implements OnInit {
    @ViewChild('settingsForm') form: NgForm;

    error: string;
    user: User;
    areDetailsUpdated: boolean = false;

    showTogglSettings: boolean = false;
    togglUser: string;
    togglPassword: string;

    /** Latest installer info pulled from `/downloads/latest.yml` at runtime —
     *  single source of truth shared with the desktop app's auto-updater. */
    timerApp$!: Observable<TimerAppDownloadInfo | null>;

    /** Template helpers — delegate to the service so the seen-version
     *  storage key lives in exactly one place. */
    hasNewTimerAppVersion(version: string): boolean {
        return this.timerAppDownload.hasNewVersion(version);
    }
    markTimerAppDownloaded(version: string): void {
        this.timerAppDownload.markDownloaded(version);
    }

    ngOnInit(): void {
        // Register hotkey for "Save Changes" action (Ctrl + Alt + S)
        this.hotkeyService.registerHotkey('ctrl+alt+s', 'Save Changes action', () => {
            if (this.form?.valid && !this.form?.pristine) {
                this.onSubmit();
            }
        });

        if (this.loginService.userId) {
            this.userService.getUserDetails(this.loginService.userId).subscribe(
                (r) => {
                    if (r.success) {
                        this.user = r.user;
                    } else {
                        this.error = r.error;
                    }
                },
                (error) => (this.error = error)
            );
        }

        this.timerApp$ = this.timerAppDownload.getInfo();
    }
    constructor(
        private loginService: LoginService,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private togglService: TogglService,
        private hotkeyService: HotkeyService,
        public desktopApp: DesktopAppService,
        private timerAppDownload: TimerAppDownloadService,
    ) {}

    onSubmit() {
        this.userService.updateOwnDetails(this.user).subscribe(
            (r) => {
                if (!r.success) {
                    this.error = r.error;
                } else {
                    this.areDetailsUpdated = true;
                }
            },
            (error) => (this.error = error)
        );
    }

    isToggleConnected() {
        return this.togglService.isLoggedIn();
    }

    onTogglSubmit() {
        this.togglService.login(this.togglUser, this.togglPassword).subscribe(
            (r) => {
                console.log('login result', r);
            }
        );
    }

    disconnectToggl() {
        this.togglService.logout();
    }

    copyLoginTokenToClipboard() {
        this.loginService.getOrRefreshToken()
            .subscribe((token) => {
                navigator.clipboard.writeText(token).then(
                    () => {
                        console.log('Token copied to clipboard');
                    },
                    (err) => {
                        console.error('Could not copy token: ', err);
                    }
                );
            });

    }
}
